import { render, staticRenderFns } from "./upaycallback.vue?vue&type=template&id=05b7d2c5"
import script from "./upaycallback.vue?vue&type=script&lang=js"
export * from "./upaycallback.vue?vue&type=script&lang=js"
import style0 from "./upaycallback.vue?vue&type=style&index=0&id=05b7d2c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports